import { ConstrainedString } from '../generic'
import { ModelPortfolioId } from '../ModelPortfolio/ModelPortfolio'

export type AccountId = ConstrainedString<'accountId'>

/**
 * name to break collision with lib.dom.d.ts
 */
export interface TumeloAccount {
  id: AccountId
  title?: string
  modelPortfolioId?: ModelPortfolioId
}

export const sampleTumeloAccount = (): TumeloAccount => {
  return {
    id: '0F5C8F93-480E-4A8B-B780-8EF63B319716' as AccountId,
    title: 'Account A',
    modelPortfolioId: '2DD1596D-9518-4304-9A06-D01708CF3707' as ModelPortfolioId,
  }
}
